/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { tokenDataAttribute, tokenIndexDataAttribute, TOKEN_CLASS_NAME } from '../../utils/labelerConstants';
import { useLabelerStore } from '../../utils/labelerStoreContext';
import { useTheme } from 'styled-components';
export const TokenRenderer = observer((props) => {
    const { tokenStore, lineStore } = props;
    const theme = useTheme();
    const { selectionStore, tokenEventListenersFactory, configStore } = useLabelerStore();
    const innerDataAttributes = { [tokenDataAttribute]: true, [tokenIndexDataAttribute]: `${tokenStore.index}` };
    const tokenEventListeners = React.useMemo(() => (configStore.isSelectionDisabled ? {} : tokenEventListenersFactory === null || tokenEventListenersFactory === void 0 ? void 0 : tokenEventListenersFactory({ tokenStore, lineStore })), [lineStore, configStore.isSelectionDisabled, tokenEventListenersFactory]);
    const isTokenInSelection = computed(() => selectionStore.selectionStart <= tokenStore.index && tokenStore.index <= selectionStore.selectionEnd).get();
    const backgroundColor = isTokenInSelection ? theme.token.selectedTokenBackground : 'transparent';
    return (React.createElement("span", Object.assign({ className: TOKEN_CLASS_NAME }, tokenEventListeners, innerDataAttributes, { style: { backgroundColor } }), tokenStore.text));
});
